import styled from "styled-components";

export const Wrapper = styled("div")(() => ({
  width: "100%",
  maxWidth: "1220px",
  margin: "0 auto",
  padding: "20px 20px 60px",
}));

export const Hero = styled("div")(({ theme }) => ({
  background: `linear-gradient(135deg, ${theme.palette.searchBg} 0%, ${theme.palette.searchBgLight} 100%)`,
  borderRadius: "16px",
  padding: "60px 48px",
  marginBottom: "56px",
  textAlign: "center",

  [theme.down("xs")]: {
    padding: "40px 24px",
    marginBottom: "40px",
  },
}));

export const HeroTitle = styled("h1")(({ theme }) => ({
  fontSize: "36px",
  fontWeight: "700",
  color: theme.palette.textWhite,
  marginBottom: "16px",
  lineHeight: "1.25",

  "& span": {
    color: theme.palette.primary,
  },

  [theme.down("xs")]: {
    fontSize: "26px",
  },
}));

export const HeroSubtitle = styled("p")(({ theme }) => ({
  fontSize: "17px",
  color: `${theme.palette.textWhite}CC`,
  lineHeight: "1.7",
  maxWidth: "680px",
  margin: "0 auto",
}));

export const StatsGrid = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(4, 1fr)",
  gap: "24px",
  marginBottom: "56px",

  [theme.down("md")]: {
    gridTemplateColumns: "repeat(2, 1fr)",
  },

  [theme.down("xs")]: {
    gridTemplateColumns: "1fr 1fr",
    gap: "16px",
    marginBottom: "40px",
  },
}));

export const StatCard = styled("div")(({ theme }) => ({
  background: theme.palette.white,
  borderRadius: "12px",
  padding: "28px 20px",
  textAlign: "center",
  boxShadow: `0 2px 12px ${theme.palette.shadowSm}`,
  border: `1px solid ${theme.palette.borderLight}`,
  transition: "box-shadow 0.2s ease",

  "&:hover": {
    boxShadow: `0 4px 20px ${theme.palette.shadowMd}`,
  },
}));

export const StatNumber = styled("div")(({ theme }) => ({
  fontSize: "34px",
  fontWeight: "800",
  color: theme.palette.primary,
  lineHeight: "1",
  marginBottom: "8px",
}));

export const StatLabel = styled("div")(({ theme }) => ({
  fontSize: "14px",
  color: theme.palette.textSecondary,
  lineHeight: "1.4",
}));

export const SectionTitle = styled("h2")(({ theme }) => ({
  fontSize: "26px",
  fontWeight: "700",
  color: theme.palette.textPrimary,
  marginBottom: "24px",
}));

export const TwoColSection = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: "40px",
  marginBottom: "56px",
  alignItems: "start",

  [theme.down("sm")]: {
    gridTemplateColumns: "1fr",
    marginBottom: "40px",
  },
}));

export const TextBlock = styled("div")(({ theme }) => ({
  "& p": {
    fontSize: "16px",
    color: theme.palette.textSecondary,
    lineHeight: "1.75",
    marginBottom: "16px",

    "&:last-child": {
      marginBottom: 0,
    },
  },
}));

export const ValuesGrid = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  gap: "24px",
  marginBottom: "56px",

  [theme.down("sm")]: {
    gridTemplateColumns: "1fr",
    marginBottom: "40px",
  },
}));

export const ValueCard = styled("div")(({ theme }) => ({
  background: theme.palette.bgAlt,
  borderRadius: "12px",
  padding: "28px 24px",
  border: `1px solid ${theme.palette.borderLight}`,
}));

export const ValueIcon = styled("div")(({ theme }) => ({
  width: "48px",
  height: "48px",
  borderRadius: "12px",
  background: theme.palette.primarySubtle,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "22px",
  marginBottom: "16px",
}));

export const ValueTitle = styled("h3")(({ theme }) => ({
  fontSize: "16px",
  fontWeight: "700",
  color: theme.palette.textPrimary,
  marginBottom: "10px",
}));

export const ValueText = styled("p")(({ theme }) => ({
  fontSize: "15px",
  color: theme.palette.textSecondary,
  lineHeight: "1.65",
  margin: 0,
}));

export const CtaBanner = styled("div")(({ theme }) => ({
  background: `linear-gradient(135deg, ${theme.palette.primary} 0%, ${theme.palette.primaryDark} 100%)`,
  borderRadius: "16px",
  padding: "48px 40px",
  textAlign: "center",

  [theme.down("xs")]: {
    padding: "36px 24px",
  },
}));

export const CtaTitle = styled("h2")(({ theme }) => ({
  fontSize: "24px",
  fontWeight: "700",
  color: theme.palette.textWhite,
  marginBottom: "12px",
}));

export const CtaText = styled("p")(({ theme }) => ({
  fontSize: "16px",
  color: `${theme.palette.textWhite}CC`,
  marginBottom: "28px",
  lineHeight: "1.6",
}));

export const CtaButton = styled("a")(({ theme }) => ({
  display: "inline-block",
  background: theme.palette.white,
  color: theme.palette.primary,
  fontWeight: "700",
  fontSize: "15px",
  padding: "12px 32px",
  borderRadius: "8px",
  textDecoration: "none",
  transition: "opacity 0.2s ease",

  "&:hover": {
    opacity: 0.9,
  },
}));
